import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from 'react-bootstrap';
import { ICFFactorTypeOption } from '../../factor-service';
import { IPersonalDataStepGM } from '../steps/PersonalDataStep';
import { blankLink } from 'config';
import { useGarantieMaxActions } from '../GarantieMax';

export interface IViewPersonalStep2Props {
  personalZipCode?: string | ICFFactorTypeOption;
  personalData: IPersonalDataStepGM | null;
}

export const ViewPersonalStep2: React.FC<IViewPersonalStep2Props> = ( {
  personalZipCode, personalData,
} ) => {
  const { t } = useTranslation( [ 'widgets', 'base' ] );
  const actions = useGarantieMaxActions();

  const onClickEditStep = React.useCallback ( ( e ) => {
    e.preventDefault();
    actions.goToStep( 'personal-data', false );
  }, [ actions ] );

  return (
    <Fragment>
      { personalData !== null && (
        <Card className="bg-none">
          <Card.Body>
            <div className="d-flex justify-content-between">
              <h3>{ t( 'bookingFunnel.steps.personalData' ) }</h3>
              <a
                href={ blankLink }
                onClick={ ( e ) => { onClickEditStep( e ); } }
                title={ t( 'base:forms.edit' ) }
              >
                { t( 'base:forms.edit' ) }
              </a>

            </div>
            <hr className="mt-3 mb-3"></hr>
            <div className="text-left">
              <div className="details-section">
                <h5>{ t( 'bookingFunnel.summary.nameAndAddress' ) }</h5>
                <p className="mb-0">{ personalData?.firstName } { personalData?.lastName }</p>
                <p className="mb-0">{ personalData?.street } { personalData?.houseNumber }</p>
                <p>{ personalZipCode } { personalData?.city }</p>
              </div>
              <div className="details-section mb-0">
                <h5>{ t( 'bookingFunnel.summary.contact' ) }</h5>
                <p className="mb-0">{ personalData?.phone }</p>
                <p>{ personalData?.email }</p>
              </div>
            </div>
          </Card.Body>
        </Card>
      ) }
    </Fragment>
  );
};
